import React, { Component, MouseEvent } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { Uuid } from "@formant/core/model/Uuid";
import { Icon } from "@formant/ui/component/common/Icon";

import { appStore } from "../../stores";
import { CircleButton } from "../common/CircleButton";
import * as styles from "./FavoriteToggle.scss";

export interface IFavoriteToggleProps {
    id: Uuid;
    className?: string;
}

@observer
export class FavoriteToggle extends Component<IFavoriteToggleProps> {
    public render() {
        const { id, className } = this.props;

        const toggled = appStore.favorites.includes(id);

        return (
            <div
                className={classnames(
                    styles["favorite-toggle"],
                    toggled && styles.toggled,
                    className,
                )}
            >
                <Icon name="device" />
                <CircleButton
                    onClick={this.onClick}
                    icon="favorite"
                    className={classnames(
                        styles.toggle,
                        styles["circle-button"],
                        styles.button,
                    )}
                />
            </div>
        );
    }

    private onClick = (event: MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        appStore.toggleFavorite(this.props.id);
    };
}
